import {Component, Input} from '@angular/core';

@Component({
  selector: 'spinner',
  template: require('./spinner.component.html')
})
export class SpinnerComponent {
  @Input() type: string = ''; // type of spinner, for now we have the default  action (yellow on buttons)
  @Input() show: boolean = false;

  constructor() {}
}
